<script>
    import {isDefined} from "../../util/isDefined";
    import KeyValueItem from "./KeyValueItem.svelte";

    export let columns = []
    export let rows = []
    export let isDisplayed = () => true

    $: rowMaps = rows.map(row => {
        return new Map((row.columns || []).map(column => {
            return [
                column.name,
                column
            ]
        }));
    })
</script>

<div class="point-report-notebook">
    {#each rowMaps as row}
        {#each columns as column, i}
            {#if isDisplayed(column) && isDefined(row.get(column.name).value)}
                <KeyValueItem title={column.name} value={row.get(column.name).value} description={row.get(column.name).description} />
            {/if}
        {/each}
    {/each}
    <slot></slot>
</div>
